import { FC, RefObject } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { PlanManagementProvider } from "../billing/PlanManagement/PlanManagementProvider";
import { WorkspaceSettingsPages } from "./constants";
import { DirectorySettings } from "./Directory/DirectorySettings";
import { BillingPage } from "./Billing/BillingPage";
import { PlansPage } from "./Plans/PlansPage";
import { WorkspaceMembers } from "./WorkspaceMembers/WorkspaceMembers";
import { DirectoryContextProvider } from "./Directory/DirectoryContextProvider";
import { IntegrationsSettings } from "./Integrations/IntegrationsSettings";
import { WorkspaceLock } from "./Lock/WorkspaceLock";
import { SettingsTabPane } from "./SettingsTabPane";

interface Props {
    scrollbars: RefObject<Scrollbars>;
}

export const WorkspacePanes: FC<Props> = ({ scrollbars }) => (
    <>
        <SettingsTabPane
            eventKey={WorkspaceSettingsPages.MEMBERS}
            title="Members"
        >
            <WorkspaceMembers />
        </SettingsTabPane>

        <SettingsTabPane
            eventKey={WorkspaceSettingsPages.INTEGRATIONS}
            title="Integrations"
        >
            <IntegrationsSettings scrollbars={scrollbars} />
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.DIRECTORY}>
            <PlanManagementProvider>
                <DirectoryContextProvider>
                    <DirectorySettings />
                </DirectoryContextProvider>
            </PlanManagementProvider>
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.LOCKS} title="Locks">
            <WorkspaceLock />
        </SettingsTabPane>

        <SettingsTabPane
            eventKey={WorkspaceSettingsPages.BILLING}
            title="Billing"
        >
            <BillingPage />
        </SettingsTabPane>

        <SettingsTabPane eventKey={WorkspaceSettingsPages.PLANS} title="Plans">
            <PlanManagementProvider>
                <PlansPage />
            </PlanManagementProvider>
        </SettingsTabPane>
    </>
);
